import { ThunkDispatch } from "core-integration/src/store";
import { updateElementControls } from "core-integration/src/store/elements/actions";
import { getElementControls } from "core-integration/src/store/elements/reducers";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SearchField } from "../../FieldRenderers";
import { SearchWrapper } from "./styles";

const ElementSearchField = () => {
  const { t } = useTranslation();
  const searchLabel = t("elementList.search", "Search Player List");
  const controls = useSelector(getElementControls);
  const dispatch = useDispatch<ThunkDispatch>();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateElementControls({ ...controls, search: e.target.value }));
  };

  return (
    <SearchWrapper>
      <SearchField
        id="search"
        name="search"
        label={searchLabel}
        labelVisibility={false}
        placeholder={searchLabel}
        onChange={handleSearchChange}
        value={controls.search}
        required={false}
      />
    </SearchWrapper>
  );
};

export default ElementSearchField;
